import { useEffect } from 'react';

import { useTaskFrameStore, useToolPermissionStore } from '@/store';

const Done = () => {
  const { currentFrame } = useTaskFrameStore();
  const { setPermission } = useToolPermissionStore();

  useEffect(() => {
    setPermission({
      labeling: {
        readable: true,
        updatable: false,
        acceptable: false,
      },
      labelingReview: {
        readable: true,
        updatable: false,
        acceptable: false,
      },
      preAnnotation: {
        acceptable: false,
      },
      aiAssist: {
        acceptable: false,
      },
    });
  }, [currentFrame?.frameSeq, currentFrame?.workState]);

  return <></>;
};

export default Done;
